<template>
    <div :class="containerClassName" v-loading="graphsLoading">
        <el-row> 
            <graph v-show="isStatistics" ref="statisticsGraph" :title="$l('graphs/STATISTICS')" v-bind:data="statistics" :config="configs.statistics" ></graph>
            <graph ref="noiseGraph" :title="$l('graphs/NOISE')" v-bind:shared="shared" v-bind:data="noise" :config="configs.noise"></graph>
            <graph  ref="spectGraph" :title="$l('graphs/SPECTRUM')" v-bind:shared="shared" v-bind:data="spectogram" :config="configs.spectogram"></graph>
            <graph v-if=" !getRealtimeEnabled || getSettingsWeather.device != 'NaN'" ref="weathGraph" :title="$l('graphs/WEATHER')" v-bind:shared="shared" v-bind:data="weather" :config="configs.weather"></graph>
            <graph v-if=" !getRealtimeEnabled || getSettingsAdio && (getSettingsAdio.AI==1 || getSettingsAdio.DI1 == 1 || getSettingsAdio.DI2 == 1) && getSettingsAdio.present == 1" ref="adioGraph" :title="$l('graphs/ADIO')" v-bind:shared="shared" v-bind:data="adio" :config="configs.adio"></graph>

        </el-row>
    </div>
</template>


<style>
    .el-loading-mask{
        
    }
    .graphs-container{
        padding: 20px;
    }

    .graphs-container.loading{
        height: calc(100vh - 150px);
        overflow: hidden;
    }

    .graph-container{
        border: 1px solid #e1e5ec;
    }
    
    .graph-body{
        height:250px;
    }
    .graph{
        height: 100%;
    }
</style>

<script>
import Graph from './Graph';
import ExportGraph from './ExportGraph';
import * as GraphConfigs from './graph-configs';
import { mapGetters } from 'vuex'
import { getDailyData, getHourlyData, setRealtimeEnabled, setSelectedDay,setSelectedHour,setSidebarVisible } from '@/store/actions'

export default {
    data(){
        return{
            options: GraphConfigs.noise,
            configs: GraphConfigs,
            noiseVisible: true,
            noiseChart: null,
            noise:{loading: false,},
            weather:{loading: false,},
            spectogram:{loading: false,},
            adio:{loading:false},
            statistics:{loading:false},
            shared:{sync: true, realtime: false},
            realtimeInterval: undefined,
            activateHour: false,
            mounted: false,
        }
    },
    computed:{
        ...mapGetters([
            'getSidebarVisible',
            'getSelectedDay',
            'getSelectedHour',
            'getRealtimeEnabled',
            'getLocalSettings',
            'getSelectedDayHours',
            'getMounted',
            'getSettingsAdio',
            'getSettingsWeather',
            'getScreenSize'
        ]),
        containerClassName: function(){
            return 'graphs-container'  +((this.loading)?' loading':'');
        },
        graphsLoading: function(){
            return this.noise.loading || this.weather.loading
        },
        isStatistics: function(){
            return this.$route.path.indexOf('/statistics') > -1;
        }
    },
    components:{
        'export-graph':ExportGraph,
        'graph':Graph
    },
    watch:{
        getRealtimeEnabled: function(enabled){
            if(enabled){
                clearInterval(this.realtimeInterval);
                this.realtimeInterval = setInterval(this.realtimeReload,1000);
                
            }else{
                clearInterval(this.realtimeInterval);
                this.reloadGraphs();
            }
        },
        getSelectedDayHours: function(hours){
            
            if(this.activateHour && hours.length>0){
                this.activateHour = false;
                var lastHour = hours[hours.length-1].split('-')[3];
                setSelectedHour(this.$store, lastHour);
                this.sendToGraphs('loadHourGraph', lastHour);
            }
        },
        getSelectedHour: function(newHour){
            
           
            if(this.getMounted && !this.getRealtimeEnabled && newHour.replace(/ /g,''))
                this.sendToGraphs('loadHourGraph');
        },
        getSelectedDay: function(newDay){
            if(this.getMounted && !this.getRealtimeEnabled)
                this.sendToGraphs('loadDayGraph');
        },
        isStatistics: function(stat){
            if(stat){
                this.sendToGraphs('loadDayGraph');
            }
        }
    },
    methods: {
        sendToGraphs: function(msg, data){
            let delayedLoading  = false;
            if(this.getScreenSize < 2 ) delayedLoading = true;
            if(this.$refs.noiseGraph)this.$refs.noiseGraph.$emit(msg,{data, delayedLoading});
            if(this.$refs.spectGraph)this.$refs.spectGraph.$emit(msg,{data, delayedLoading});
            if(this.$refs.weathGraph)this.$refs.weathGraph.$emit(msg,{data, delayedLoading});
            if(this.$refs.adioGraph)this.$refs.adioGraph.$emit(msg,{data, delayedLoading});
            if(this.isStatistics) this.$refs.statisticsGraph.$emit(msg, {data, delayedLoading});
        },
        realtimeReload: function(){
            let delayedLoading  = false;
            if(this.getScreenSize < 2 ) delayedLoading = true;
            if(this.$refs.noiseGraph)this.$refs.noiseGraph.$emit('realtimeReload', {delayedLoading});
            if(this.$refs.spectGraph)this.$refs.spectGraph.$emit('realtimeReload', {delayedLoading});
            if(this.$refs.weathGraph)this.$refs.weathGraph.$emit('realtimeReload', {delayedLoading});
            if(this.$refs.adioGraph)this.$refs.adioGraph.$emit('realtimeReload', {delayedLoading});
            
        },
        reloadGraphs: function(){
            if(!this.getMounted) return;
            if(this.getSelectedHour != '' && !this.isStatistics && this.getSelectedDay ){
                this.sendToGraphs('loadHourGraph');
            }
            else if(this.getSelectedDay.year){
                //setSelectedDay(this.$store, JSON.parse(JSON.stringify(this.getSelectedDay)));
                //if(this.getSelectedDayHours.length > 0){
                //    setSelectedHour(this.$store, this.getSelectedDayHours[this.getSelectedDayHours.length-1].split('-')[3]);
                //}
                this.sendToGraphs('loadDayGraph')
            }else{
                var date = new Date();
                setSelectedDay(this.$store, {day: date.getDate(), month:date.getMonth(), year:date.getFullYear()})
                this.activateHour = true;
                this.sendToGraphs('loadDayGraph')
            }
            if(this.getLocalSettings.interface){
                this.shared.sync = this.getLocalSettings.interface.syncgraphs;
            }
            //GraphConfigs.noise.chart.events.selection= (event)=>this.selection(this.$refs.noiseChart,event);
            
        }

    },
    mounted: function(){
        if(this.getRealtimeEnabled){
            this.realtimeInterval = setInterval(this.realtimeReload,1000);
        }else{
            this.reloadGraphs();
        }
        /*if(this.$route.fullPath == '/realtime'){
             setRealtimeEnabled(this.$store, true);
        }else{
            setRealtimeEnabled(this.$store, false);
            this.reloadGraphs();
        }*/
        //setTimeout(()=>{
        //    this.mounted = true;
        //},500)
    },
    destroyed: function(){
        setRealtimeEnabled(this.$store, false);
    }
    
}
</script>




// WEBPACK FOOTER //
// Graphs.vue?459cb030